import React from 'react';
import { AppContext } from '../AppContext';

const Achievements = (props) => {
    const app = React.useContext(AppContext);
    const usersAchievements = app.userdata.achievements || [];
    const allAchievements = app.achievements.allAchievements;
    for (const achievement of allAchievements) {
        if (usersAchievements.indexOf(achievement.name) !== -1) {
            achievement.owned = true;
        }
        //achievement.owned = Math.random() < 0.5;
    }
    const earned = allAchievements.filter((achievement) => achievement.owned).length;
    const total = allAchievements.length;

    return (

        <div id="Achievements1" className="page1 noAnimate">
            <div className="wrapper">
                <h1> <a className="backButton" href="#"></a> Achievements</h1>

                <ul data-model="achievements" data-template="achievement" className="achievementList">
                    {allAchievements.map((achievement) => (
                        <li key={achievement.name} className={(achievement.owned ? "" : "notFound") + " " + (achievement.isHidden === "true" ? "isHidden" : "")}>
                            <img src={'assets/Achievements/' + achievement.image} />
                            <div className='points' data-inner-text="points">{achievement.points}</div>
                            <div className='title' data-inner-text="title">{achievement.title}</div>
                            <div className='description' data-inner-text="description">{achievement.description}</div>
                        </li>
                    ))}
                </ul>
                <div style={{ textAlign: "center" }}>
                    {earned} / {total}
                </div>
            </div>
        </div>
    )
};

export default Achievements;

